<template lang="pug">
  b-card
    b-card.no-shadow.bg-light
      b-row.align-items-center
        b-col
          b-form-group(label="El bot no pudo responder esta pregunta, ¿Qué quieres hacer con ella?")
            b-form-textarea.bg-white(placeholder="Pregunta", :value="text", readonly)
    b-form-group.mb-4
      p.mb-0 Agregar pregunta a bloque
      p.text-secondary.mb-2 Este bloque es sugerido o selecciona de la lista el bloque correcto
      b-form-row.align-items-center
        b-col.mb-2.mb-md-0
          k-select(v-model="blocks_id", placeholder="Buscar bloque...", :options="parsed_questions")
        b-col(md="auto")
          b-button.d-block.ml-auto.ml-md-0(variant="soft-success", @click="addToBlock", :disabled="loading || !blocks_id")
            .d-flex.align-items-center
              span Agregar
              b-spinner.ml-2(small, variant="primary", v-if="loading")
              check-icon.ml-2.icon-sm(v-else)
    b-form-row.align-items-center.justify-content-end
      b-col.mb-2.mb-md-0(cols="auto")
        b-button(variant="soft-primary", @click="$emit('create-block', id)", :disabled="loading") Crear nuevo bloque
      b-col(cols="auto")
        b-button(variant="soft-danger", @click="deleteSuggestion", :disabled="loading")
          .d-flex.align-items-center
            span Eliminar
            trash-2-icon.ml-2.icon-sm

</template>

<script>
  import {createNamespacedHelpers, mapActions} from "vuex";
  const accountController = createNamespacedHelpers('account')
  const questionController = createNamespacedHelpers('question')
  const suggestionsController = createNamespacedHelpers('suggestion')
  import Select from '@/components/Select.vue'
  import treeselectOptions from '@/data/treeselect-options'

  export default {
    data: () =>{
      return {
        treeselect_options: treeselectOptions,
        loading: false,
        blocks_id: null
      }
    },
    props: {
      id: {
        default: null
      },
      text: {
        type: String,
        default: ''
      },
      qb_id: {
        default: null
      }
    },
    computed: {
      ...questionController.mapState({
        blocks: state => state.blocks
      }),
      parsed_questions () {
        return this.blocks.map(q => {
          return {
            label: q.name || `Bloque ${q.id}`,
            id: q.id
          }
        })
      }
    },
    methods: {
      ...mapActions(['suggestion/addToBlock', 'suggestion/destroy']),
      addToBlock() {
        let self = this
        this.loading = true

        this['suggestion/addToBlock']({
          id: self.id,
          train: true,
          block_id: self.blocks_id,
          callback: res => {
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Pregunta agregada a bloque')
              self.$store.commit('suggestion/removeItem', {id: self.id})
              self.$emit('get-suggestion')
            }
          }
        })
      },
      deleteSuggestion () {
        let self = this
        this.loading = true

        this['suggestion/destroy']({
          account_id: self.$route.params.account_id,
          id: self.id,
          callback: res => {
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$emit('get-suggestion')
            }
          }
        })
      }
    },
    mounted() {
      this.blocks_id = this.qb_id
    },
    components: {
      'k-select': Select
    }
  }
</script>

<style lang="scss" scoped>
</style>